import styled from 'styled-components';
import C from '@assets/themes/colors';
import D from '@assets/themes/dimensions';

export const Root = styled.div`
  margin-top:5px;
  border-top: 1px solid ${C.LIGHT_GRAY};
  display: flex;
  flex-direction: column;
`;


export const SectionContainer = styled.div`
  max-width: 281px;
  width: auto;
  display:inline-block;
  margin:5px 8px 2px 8px;
  position:relative;  
`;


interface IRootProps {
  widthValue?: string;
  opacityValue?: string;
  flex?: Boolean;
  selected?: boolean;
  transparent?: boolean;
}

export const ItemContainer = styled.div`
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 10px;
  flex: 1;
  height: ${D.BRAND_ITEM_HEIGHT}px;
  width: ${D.BRAND_ITEM_WIDTH}px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction:column;
  border-radius: 5px;
  background-color: ${C.WHITE};    
  overflow: hidden;
  border: ${(props: IRootProps) => (props.selected ? `1px solid ${C.DARK_ORANGE}` : `1px solid white`)};
  cursor: pointer;
  
  &:hover {
    transform: scale(1.02);
    border: ${(props: IRootProps) => (props.selected ? `1px solid ${C.DARK_ORANGE}` : `1px solid rgba(32, 64, 120, 0.3)`)};
    box-shadow: 2px 2px 10px 2px rgba(0, 0, 0, 0.05);    
  }
  
`;

interface IProps {
  zIndexValue?: string;
  positionValue?: string;
  opacityValue?: string;
  transparent?: boolean;
}

export const ImgContainer = styled.img`
  display: flex;
  text-align: center;
  box-sizing: border-box;
  
  object-fit: contain;
  position: ${(props: IProps) => (props.positionValue ?? 'auto')};
  opacity: ${(props: IProps) => (props.opacityValue ?? '1')};
  z-index: ${(props: IProps) => (props.zIndexValue ?? 'auto')};

  ${(props: IRootProps) => (props.transparent ? `{
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUAQMAAAC3R49OAAAABlBMVEX////09PQtDxrOAAAAE0lEQVQI12P4f4CBKMxg/4EYDAAFkR1NiYvv7QAAAABJRU5ErkJggg==');
    background-image: linear-gradient(45deg, $color 25%, transparent 25%), linear-gradient(-45deg, $color 25%, transparent 25%), linear-gradient(45deg, transparent 75%, $color 75%), linear-gradient(-45deg, transparent 75%, $color 75%);
    background-size: 20px 20px;
    background-position: 0 0, 0 10px, 10px -10px, -10px 0px;
  }` : ``)};
`

export const ImgContainerSimple = styled.img`
  height: 100px;
  display: flex;
  
  width: 85%;
  text-align: center;
  object-fit: contain;
  box-sizing: border-box;
  ${(props: IRootProps) => (props.transparent ? `{
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUAQMAAAC3R49OAAAABlBMVEX////09PQtDxrOAAAAE0lEQVQI12P4f4CBKMxg/4EYDAAFkR1NiYvv7QAAAABJRU5ErkJggg==');
    background-image: linear-gradient(45deg, $color 25%, transparent 25%), linear-gradient(-45deg, $color 25%, transparent 25%), linear-gradient(45deg, transparent 75%, $color 75%), linear-gradient(-45deg, transparent 75%, $color 75%);
    background-size: 20px 20px;
    background-position: 0 0, 0 10px, 10px -10px, -10px 0px;
  }` : ``)};
    
 `;